import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function FeaturedComics() {
  const featured = comics.slice(0, 8);

  return (
    <section className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              热门推荐
            </h2>
            <p className="text-foreground-500 text-sm mt-2">精选优质韩漫，即刻开启阅读之旅</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden sm:flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium whitespace-nowrap transition-colors"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop="">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.cover}
                  alt={`${comic.title} - 韩国漫画`}
                  title={`${comic.title} - 韩漫在线免费`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <p className="text-white text-xs line-clamp-2">{comic.description}</p>
                </div>
                <div className="absolute top-2 left-2">
                  <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full whitespace-nowrap ${
                    comic.status === 'ongoing'
                      ? 'bg-primary-500 text-white'
                      : 'bg-foreground-700 text-white'
                  }`}>
                    {comic.status === 'ongoing' ? '连载中' : '已完结'}
                  </span>
                </div>
                <div className="absolute top-2 right-2 flex items-center gap-0.5 bg-black/60 backdrop-blur-sm rounded-full px-1.5 py-0.5">
                  <i className="ri-star-fill text-amber-400 text-[10px]"></i>
                  <span className="text-white text-[10px] font-medium">{comic.rating}</span>
                </div>
              </div>
              <h3 className="text-foreground-900 font-semibold text-sm line-clamp-1 group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
              <div className="flex items-center gap-2 mt-1 text-foreground-400 text-xs">
                <span>{comic.author}</span>
                <span>·</span>
                <span>{comic.chapters}话</span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-1 text-primary-500 hover:text-primary-600 text-sm font-medium whitespace-nowrap"
          >
            查看全部推荐
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}